import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Checkbox, Col, Form, Input, Modal, Row } from "antd";
import Styles from "./Styles";
import { apiPostUsersLogin } from "../../api/api";
import { isEmpty } from "../../utils/comm";

import { Auth } from "aws-amplify";

const requiredRules = { required: true, message: "필수입력입니다." };

class LoginEx extends React.Component {
  constructor() {
    super();

    // 자동로그인 체크박스 설정
    const mAL = JSON.parse(localStorage.getItem("autoLogin"));
    const mLI = localStorage.getItem("loginId");
    const mLP = localStorage.getItem("loginPw");

    let email = "";
    let password = "";
    let autoLogin = false;

    if (mAL && !isEmpty(mLI) && !isEmpty(mLP)) {
      email = mLI;
      password = mLP;
      autoLogin = true;

      setTimeout(() => {
        document.getElementById("btnSubmit").click();
      }, 1000);
      //document.getElementById("btnSubmit").click();
      //apiPostUsersLoginCall();
    }

    this.state = {
      username: "",
      email: email,
      password: password,
      new_password: "",
      code: "",
      stage: "SIGNIN",
      cognito_username: "",
      autoLogin: autoLogin,
    };
  }

  handleChange = (event) => {
    const { id, value } = event.target;

    this.setState({ [id]: value });
  };

  handleCheckChange(checked) {
    this.setState({ autoLogin: checked });
  }

  componentDidMount() {
    Auth.currentAuthenticatedUser()
      .then((loginUser) => {
        if (loginUser) {
          this.moveMenu();
        }
      })
      .catch(() => {});
  }

  //     // 권한별 메뉴 이동
  moveMenu = () => {
    switch (sessionStorage.getItem("authCd")) {
      case "AUC00010": // 회사 관리자
        sessionStorage.setItem("tabTitle", "서비스 사용자 관리");
        window.location.replace("/home");
        break;
      case "AUC00020": // 사업장 관리자
        sessionStorage.setItem("tabTitle", "HOME");
        window.location.replace("/home");
        break;
      case "AUC00030": // 디바이스 관리자
        sessionStorage.setItem("tabTitle", "디바이스 상태 관리");
        window.location.replace("/manageDevice");
        break;
      case "AUC00090": // 플랫폼 관리자
        sessionStorage.setItem("tabTitle", "서비스 이용 관리");
        window.location.replace("/manageServiceUse");
        break;
      case "AUC00040": // 일반사용자
        sessionStorage.setItem("tabTitle", "HOME");
        window.location.replace("/home");
        break;
    }
  };

  signIn = async () => {
    let self = this;

    function loginFailed() {
      Modal.confirm({
        title: "로그인",
        icon: null,
        content: "아이디 또는 패스워드가 잘못되었습니다.",
        okText: "확인",
        centered: true,
        cancelButtonProps: { style: { display: "none" } },
      });
    }

    function loginNotFoundId() {
      Modal.confirm({
        title: "로그인",
        icon: null,
        content: "아이디가 존재하지 않습니다.",
        okText: "확인",
        centered: true,
        cancelButtonProps: { style: { display: "none" } },
      });
    }

    if (isEmpty(self.state.email)) {
      Modal.confirm({
        title: "로그인",
        icon: null,
        content: "아이디를 입력하세요.",
        okText: "확인",
        centered: true,
        cancelButtonProps: { style: { display: "none" } },
      });
      return;
    }
    if (isEmpty(self.state.password)) {
      Modal.confirm({
        title: "로그인",
        icon: null,
        content: "패스워드를 입력하세요.",
        okText: "확인",
        centered: true,
        cancelButtonProps: { style: { display: "none" } },
      });
      return;
    }

    const goToFindPassword = (hasReset) => {
      // 비밀번호 찾기로 이동 (본인인증 무시)
      // 사용자 풀 등록시 이메일 인증 상태로 저장하는 것으로 협의되어 비밀번호 변경처리 진행하지 않음
      this.props.navigate("/findPassword", {
        state: {
          isNewPasswordChallenge: true,
          userAttributes: {
            loginId: self.state.email,
            loginPw: self.state.password,
          },
        },
      });
    };

    try {
      const user = await Auth.signIn({
        username: self.state.email,
        password: self.state.password,
      });

      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        // 비밀번호 찾기로 이동 (본인인증 무시)
        // 사용자 풀 등록시 이메일 인증 상태로 저장하는 것으로 협의되어 비밀번호 변경처리 진행하지 않음
        this.props.navigate("/findPassword", {
          state: {
            isNewPasswordChallenge: true,
            userAttributes: {
              loginId: self.state.email,
              loginPw: self.state.password,
            },
          },
        });
      } else {
        // const test = await Auth.currentAuthenticatedUser();

        this.setState({ stage: "SIGNEDIN", cognito_username: user.username });

        const loginModel = {
          loginId: self.state.email,
          loginPw: self.state.password,
        };

        try {
          const response = await apiPostUsersLogin(loginModel);

          if (response.data.code === 0) {
            const data = response.data.data;
            // 토큰 정보 저장
            sessionStorage.setItem("cognitoUserSession", user.getSignInUserSession());
            sessionStorage.setItem("corners-token", user.getSignInUserSession().getIdToken().getJwtToken());
            sessionStorage.setItem("userId", data.userId);
            sessionStorage.setItem("authCd", data.authCd);
            sessionStorage.setItem("siteNm", data.siteNm);
            sessionStorage.setItem("email", data.email);
            sessionStorage.setItem("userName", data.userName);
            sessionStorage.setItem("tel1", data.tel1);
            sessionStorage.setItem("loginId", data.loginId);
            sessionStorage.setItem("siteId", data.siteId);
            sessionStorage.setItem("authNm", data.authNm);
            sessionStorage.setItem("compId", data.compId);
            sessionStorage.setItem("svcCd", data.svcCd);
            localStorage.setItem("autoLogin", this.state.autoLogin);

            if (this.state.autoLogin) {
              localStorage.setItem("loginId", self.state.email);
              localStorage.setItem("loginPw", self.state.password);
            } else {
              localStorage.removeItem("loginId");
              localStorage.removeItem("loginPw");
              localStorage.removeItem("autoLogin");

              // localStorage.clear(); // 기타 플러그인에서 사용중인 것으로 추정... 전체 클리어 할 경우 Auth 관련 함수 정상 작동하지 않음
            }
            // 메뉴 이동
            this.moveMenu();
          } else if (response.data.code === 21) {
            loginFailed();
          } else if (response.data.code === 40) {
            loginNotFoundId();
          }
        } catch (e) {}
      }
    } catch (error) {
      if (error.name === "PasswordResetRequiredException") {
        this.props.navigate("/findPassword");
      } else {
        // throw error;
        loginFailed();
      }
    }
  };

  render() {
    return (
      <Styles>
        <div className='login-box'>
          <h1>LOGIN</h1>
          <Form
            name='basic'
            initialValues={{ remember: true }}
            autoComplete='off'
            className='frm-login'
            onSubmitCapture={this.signIn}
          >
            <Form.Item rules={[{ ...requiredRules }]}>
              <Input
                placeholder='아이디(메일주소)'
                id='email'
                name='email'
                value={this.state.email}
                onChange={this.handleChange}
              />
            </Form.Item>

            <Form.Item rules={[{ ...requiredRules }]}>
              <Input.Password
                placeholder='패스워드'
                id='password'
                name='password'
                value={this.state.password}
                onChange={this.handleChange}
              />
            </Form.Item>

            <Form.Item name='autoLogin' valuePropName='checked'>
              <Row justify='space-between'>
                <Col>
                  <Checkbox
                    id='autoLogin'
                    name='autoLogin'
                    onChange={(e) => {
                      this.handleCheckChange(e.target.checked);
                    }}
                    checked={this.state.autoLogin}
                  >
                    로그인유지
                  </Checkbox>
                </Col>
                <Col>
                  <Link to='/findPassword'>패스워드 변경</Link>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Button id='btnSubmit' type='primary' htmlType='submit' className='btn-large'>
                로그인
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Styles>
    );
  }
}

function LoginR(props) {
  let navigate = useNavigate();
  return <LoginEx {...props} navigate={navigate} />;
}

export default LoginR;
